import { Injectable, inject } from '@angular/core';
import { MovesService } from '../moves/moves.service';
import { RoomService } from '../room/room.service';
import { RoomListService } from '../room-list/room-list.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { InitService } from '../init/init.service';
import { DepositService } from '../deposit/deposit.service';

@Injectable({
  providedIn: 'root',
})
export class SignOutService {
  private movesService = inject(MovesService);
  private roomService = inject(RoomService);
  private roomListService = inject(RoomListService);
  private profileService = inject(ProfileService);
  private initService = inject(InitService);
  private depositService = inject(DepositService);

  async signOut(): Promise<void> {
    this.depositService.signOut();
    this.movesService.signOut();
    this.roomListService.signOut();
    this.roomService.signOut();
    this.profileService.reset();
    this.initService.reset();
  }
}
